import Vue from 'vue';
import "vant/lib/index.css";
import "vant/lib/icon/local.css";
import '@vant/touch-emulator'; // 桌面端自动将 mouse 事件转换成对应的 touch 事件

import {
    Image as VanImage,
    Button,
    Form,
    Field,
    Checkbox,
    CheckboxGroup,
    Tabbar,
    TabbarItem,
    RadioGroup,
    Radio,
    Dialog,
    Cell,
    CellGroup,
    Step,
    Steps,
    Popup,
    Tab,
    Tabs,
    Icon,
    Swipe,
    SwipeItem,
    NavBar,
    Picker,
    Toast,
    Area,
    Switch,
    AddressList,
    Empty,
    CountDown,
    Grid,
    GridItem,
    Tag,
    List,
    Loading,
    Uploader,
    Sticky,
    Calendar,
    PullRefresh,
    PasswordInput,
    NumberKeyboard,
    Search,
    Rate,
    NoticeBar,
} from 'vant';

Toast.setDefaultOptions({ overlay: true });
Toast.setDefaultOptions('loading', { duration: 0 });

Vue
    .use(VanImage)
    .use(Button)
    .use(Form)
    .use(Field)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(Tabbar)
    .use(TabbarItem)
    .use(RadioGroup)
    .use(Radio)
    .use(Dialog)
    .use(Cell)
    .use(CellGroup)
    .use(Step)
    .use(Steps)
    .use(Popup)
    .use(Tab)
    .use(Tabs)
    .use(Icon)
    .use(Swipe)
    .use(SwipeItem)
    .use(NavBar)
    .use(Picker)
    .use(Toast)
    .use(Area)
    .use(Switch)
    .use(AddressList)
    .use(Empty)
    .use(CountDown)
    .use(Grid)
    .use(GridItem)
    .use(Tag)
    .use(List)
    .use(Loading)
    .use(Uploader)
    .use(Sticky)
    .use(Calendar)
    .use(PullRefresh)
    .use(PasswordInput)
    .use(NumberKeyboard)
    .use(Search)
    .use(Rate)
    .use(NoticeBar)